import React, { useState, useEffect, useRef } from "react";
import MaterialTable from "material-table";
import axios from "axios";
import { API } from "../../backend";
import authHeader from "../../services/auth-header";
import { Paper } from "@material-ui/core";
import { ToastContainer, toast } from "react-toastify";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import Helper from "../../Helper";
import { useForm } from "react-hook-form";
import CheckButton from "react-validation/build/button";
import Form from "react-validation/build/form";
import Tooltip from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

import { getTrans as t } from "../../Localization/translations";
// import DeletePaymentSchedulesService from "../../services/contract/paymentSchedule/deletePaymentSchedulesService";
import EditContractLoanService from "../../services/contract/editContractLoanService";
import ButtonLoading from "../../components/Loder/buttonLoading";
import CurrencyInput from "react-currency-input-field";
import ContractPaymentDetails from "../../Layouts/contracts/components/Paymentdetails/ViewPaymentDetail/PaymentDetailview";
import AddPaymentSchedules from "../../Layouts/contracts/components/add-paymentSchedules";
import EditPaymentSchedules from "../../Layouts/contracts/components/editPaymentSchedule";

function PaymentScheduleList({ id, refresh }) {

  const [items, setItems] = useState([]);
  const [paymentitems, setPaymentItems] = useState([]);
  const [amount, setamount] = useState("");
  const [noofpayments, setNoofpayments] = useState("");
  const paymentRef = useRef();
  // contract
  const [contract_number, setContract_number] = useState("");
  const [start_date, setStart_date] = useState("");
  const [contract_term, setContract_term] = useState("");
  const [address_id, setAdddressId] = useState();
  const [contract_type, setContract_type] = useState("");
  const [contractID, setContractID] = useState();
  const [end_date, setEnd_date] = useState("");
  const [customer_name, setCustomer_name] = useState("");
  const [paymentstartdate, setPaymentStartDate] = useState("");
  const [paymentschedulecount, setPaymentscheduleCount] = useState("");
  const [loanamount, setLoanAmount] = useState("");
  const [iir, setIir] = useState();
  const [interestcalculationmethod, setInterestCalculationMethod] =
    useState("");
  const [repaymentprocedure, setRepaymentProcedure] = useState("");
  const [timecountingmethod, setTimeCountingMethod] = useState("");
  const [interestpostingfrequency, setInterestpostingFrequency] = useState("");
  const [paymentmethod, setPaymentMethod] = useState("");
  const [paymentrule, setPaymentRule] = useState("");
  const [paymentfrequency, setPaymentFrequency] = useState("");
  const [deposit_amount, setDeposit_amount] = useState(0);
  const [feesontime, setFeesOneTime] = useState(0);
  const [tax_rate_rent, setTax_Rate_Rent] = useState(0);
  const [tax_rate_fee, setTax_Rate_Fee] = useState(0);
  const [asset_count, setAsset_count] = useState(0);
  const [payment_count, setPayment_count] = useState(0);
  const [successful, setSuccessful] = useState(false);
  const [loading, setLoading] = useState(false);
  const [customer_id, setCustomer_id] = useState("");
  const [showaddpayment, setShowAddPayment] = useState(false);
  const [showeditpayment, setShowEditPayment] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const [paymentscheduleenddate, setPaymentScheduleEnddate] = useState(
    new Date()
  );
  const [paymentid, setPaymentid] = useState("");
  const [attribute, setAttribute] = useState([
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
  ]);
  const [taxsetup, setTaxSetup] = useState("")
  const [refreshPaymentDetails, setRefreshPaymentDetails] = useState(false);
  useEffect(() => {
    if (refreshPaymentDetails) {
      setRefreshPaymentDetails(false); // Reset the flag
    }
  }, [refreshPaymentDetails]);


  useEffect(() => {
    axios.get(API + 'contracts/companysetting-taxsetupview', { headers: authHeader() })
      .then((response) => {
        setTaxSetup(response.data.tax_setup)
      })
  }, []);

  const handelDefault = () => {
    let url = API + "contracts/payment-view/" + id.contract_id + "/";
    axios.get(url, { headers: authHeader() }).then((response) => {
      setItems(response.data);
      setamount(response.data ? response.data[0].amount : "");
      setNoofpayments(
        response.data ? response.data[0].no_of_payments : ""
      );
      
      refresh(true);
      try {
        const responsepay = axios.get(`${API}contracts/paymentScheduleCalculation/?id=${id.contract_id}`, {
          headers: authHeader(),
        });
        responsepay.then((response) => {{setPaymentItems(response.data.response)} })
      } catch (error) {
        console.error('Error fetching payment data:', error);
      }
    })
  };

  // const handleEdit = (payment_id) => {
  //   setPaymentid(payment_id);
  //   setShowEditPayment(true);
  // };

  useEffect(() => {
    handelDefault();
    EditContractLoanService.getContract(id.contract_id).then((response) => {
      setContract_number(response.data.contract_number);
      setStart_date(response.data.start_date);
      setContract_term(response.data.contract_term);
      setAdddressId(response.data.address);
      setContract_type(response.data.contract_type);
      setContractID(response.data.contractID);
      setPaymentStartDate(response.data.paymentstartdate);
      setEnd_date(response.data.end_date);
      setCustomer_name(response.data.customer_name);
      setPaymentRule(response.data.paymentrule);
      setDeposit_amount(response.data.deposit_amount);
      setFeesOneTime(response.data.one_time_fee);
      setTax_Rate_Rent(response.data.tax_rate_rent);
      setTax_Rate_Fee(response.data.tax_rate_fee);
      setPaymentFrequency(response.data.paymentfrequency);
      setPaymentscheduleCount(response.data.payment_count);
      setIir(response.data.iir);
      setTimeCountingMethod(response.data.timecountingmethod);
      setCustomer_id(response.data.party);
      setSelectedValue(response.data.party);
      setLoanAmount(response.data.loanamount);
      setPaymentMethod(response.data.paymentmethod);
      setInterestCalculationMethod(response.data.interestcalculationmethod);
      setInterestpostingFrequency(response.data.interestpostingfrequency);
      setRepaymentProcedure(response.data.repaymentprocedure);
      setAsset_count(response.data.asset_count);
      setPaymentRule(response.data.paymentrule)
      setPayment_count(response.data.payment_count);
      setAttribute([
        { attribute: response.data.contractattribute1 },
        { attribute: response.data.contractattribute2 },
        { attribute: response.data.contractattribute3 },
        { attribute: response.data.contractattribute4 },
        { attribute: response.data.contractattribute5 },
        { attribute: response.data.contractattribute6 },
        { attribute: response.data.contractattribute7 },
        { attribute: response.data.contractattribute8 },
        { attribute: response.data.contractattribute9 },
        { attribute: response.data.contractattribute10 },
        { attribute: response.data.contractattribute11 },
        { attribute: response.data.contractattribute12 },
        { attribute: response.data.contractattribute13 },
        { attribute: response.data.contractattribute14 },
        { attribute: response.data.contractattribute15 },
      ]);

      reset({
        address: response.data.address,
        selectedValue: response.data.party,
        startdate: response.data.start_date,
      });
    });
  }, [id.contract_id]);

  // const handelDelete = (id) => {
  //   confirmAlert({
  //     title: "",
  //     message: "Are you sure you want to delete this PaymentSchedule?.",
  //     buttons: [
  //       {
  //         label: "Yes",
  //         onClick: () => {
  //           DeletePaymentSchedulesService.deletePaymentsSchedules(id).then(
  //             (response) => {
  //               if (response.data.success) {
  //                 toast.success(`${response.data.response}`, {
  //                   position: "top-right",
  //                   autoClose: 1000,
  //                   hideProgressBar: false,
  //                   pauseOnHover: true,
  //                   draggable: true,
  //                   progress: undefined,
  //                   theme: "light",
  //                 });
  //                 handelDefault();
  //                 setRefreshPaymentDetails(true);
  //               } else {
  //                 toast.error(`${response.data.error}`, {
  //                   position: "top-right",
  //                   autoClose: 1000,
  //                   hideProgressBar: false,
  //                   pauseOnHover: true,
  //                   draggable: true,
  //                   progress: undefined,
  //                   theme: "light",
  //                 });
  //               }
  //             }
  //           )
  //           // .catch((error) => {
  //           //   toast.error('Something went wrong, Please log a support ticket or send email to support@athenafintech.com', {
  //           //     position: "top-right",
  //           //     autoClose: 4000,
  //           //     hideProgressBar: false,
  //           //     pauseOnHover: true,
  //           //     draggable: true,
  //           //     progress: undefined,
  //           //     theme: "light",
  //           //   })
      
  //           // });
  //         },
  //       },
  //       {
  //         label: "No",
  //       },
  //     ],
  //   });
  // };
  
  const handleadd = (id) => {
    if (items && items.length > 0) {
      let end_date_send = new Date(items[items.length - 1].end_date);
      end_date_send.setDate(end_date_send.getDate() + 1);
      setPaymentScheduleEnddate(end_date_send);
      setShowAddPayment(true);
    } else {
      setPaymentScheduleEnddate(id.contract_start_date);
      setShowAddPayment(true);
    }
  };

  const {
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();
  const form = useRef();
  const checkBtn = useRef();

  const handleRegister = () => {
    setSuccessful(false);
    setLoading(true);
    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      EditContractLoanService.editContract(
        id.contract_id,
        contract_number,
        contract_term,
        Helper.DatePicker(start_date),
        Helper.DatePicker(end_date),
        Helper.DatePicker(paymentstartdate),
        address_id,
        contract_type,
        loanamount,
        iir,
        interestcalculationmethod,
        repaymentprocedure,
        timecountingmethod,
        // interestpostingfrequency,
        paymentmethod,
        deposit_amount,
        feesontime,
        tax_rate_rent,
        tax_rate_fee,
        selectedValue,
        attribute,
        paymentfrequency,
        paymentrule
      ).then((response) => {
        if (response.data.success) {
          setSuccessful(true);
          setLoading(false);
          toast.success(`Updated successfully`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else {
          setLoading(false);
          toast.error(`${response.data.error}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setSuccessful(false);
        }
      })
    }
  };

  return (
    <>
      {showaddpayment === false ? (
        showeditpayment === false ? (
          <>
            <div className="row py-2 mt-2">
              <ToastContainer />
              <div className="col-md-12">
                <div className=" mb-0">
                  <div className="header pb-0">
                    <div className="d-lg-flex">
                      <div>
                        <h5 className="mb-0">{t("Payment Schedules")}</h5>
                      </div>
                      {contract_type === 'Loan' &&
                        <div className="ms-auto my-auto mt-lg-0 mt-4">
                          <div className="ms-auto my-auto">
                            <div onClick={() => handleadd(id)}>
                              <button
                                className="add-address add btn btn-primary mb-0"
                                id="add-task"
                              >
                                +&nbsp; {t("New Payment Schedules")}
                              </button>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                  <div className="body">
                    <div className="p-0">
                      <MaterialTable
                        ref={paymentRef}
                        style={{
                          padding: "0.5rem 0.5rem",
                          backgroundColor: "var(--bs-table-bg)",
                          borderBottomWidth: "1px",
                          boxShadow:
                            "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                        }}
                        columns={[
                          {
                            title: `${t("No. Of Payments")}`,
                            field: "no_of_payments",
                            render: rowData => <><div className="d-xl-none tc d-md-none d-lg-none">{t("No. Of Payments")}</div><div >{(rowData.no_of_payments)}</div></>,
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("Payment Type")}`,
                            field: "payment_type",
                            render: rowData => <><div className="d-xl-none tc d-md-none d-lg-none">{t("Payment Type")}</div><div >{(rowData.payment_type)}</div></>,
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("Payment Amount")}`,
                            field: "amount",
                            render: (rowData) => <><div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                            >{t("Payment Amount")}</div>
                              <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.amount)}</div></>,
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "right",
                            },
                            // cellStyle: {
                            //   textAlign: "right",
                            //   fontSize: 12,
                            // },
                          },
                          {
                            title: `${t("Start Date")}`,
                            field: "start_date",
                            render: (rowData) => <><div className="d-xl-none tc d-md-none d-lg-none">{t("Start Date")}</div><div >{
                              rowData.start_date
                                ? Helper.DateNormal(rowData.start_date)
                                : "None"}</div></>,
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("End Date")}`,
                            field: "end_date",
                            render: (rowData) =>
                              <><div className="d-xl-none tc d-md-none d-lg-none">{t("End Date")}</div><div >{
                                rowData.end_date
                                  ? Helper.DateNormal(rowData.end_date)
                                  : "None"}</div></>,
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                        ]}
                        data={items}
                        // actions={[
                        //   (rowData) => ({
                        //     icon: () =>
                        //       contract_type === "Loan" ? (
                        //         <img
                        //         src={
                        //           process.env.PUBLIC_URL +
                        //           "/static/images/ic-edit.svg"
                        //         }
                        //         alt=""
                        //       />
                        //       ) : (
                        //        "" 
                        //       ),
                        //     tooltip: "Edit",
                        //     onClick: (event, rowData) => {
                        //       handleEdit(rowData.id);
                        //     },
                        //   }),
                        //   // {
                        //   //   icon: () => (
                        //   //     <img
                        //   //       src={
                        //   //         process.env.PUBLIC_URL +
                        //   //         "/static/images/ic-edit.svg"
                        //   //       }
                        //   //       alt=""
                        //   //     />
                        //   //   ),
                        //   //   tooltip: "Edit",
                        //   //   onClick: (event, rowData) => {
                        //   //     handleEdit(rowData.id);
                        //   //   },
                        //   // },
                        //   (rowData) => ({
                        //     icon: () =>
                        //       contract_type === "Loan" ? (
                        //         <img
                        //           src={
                        //             process.env.PUBLIC_URL +
                        //             "/static/images/ic-delete.svg"
                        //           }
                        //           alt="Delete"
                        //         />
                        //       ) : null, // Return null if payment_type is not 'Rent'
                        //     tooltip: "Delete",
                        //     onClick: (event, rowData) => {
                        //       handelDelete(rowData.id);
                        //     },
                        //   }),
                        //   // {
                        //   //   icon: () => (
                        //   //     <img
                        //   //       src={
                        //   //         process.env.PUBLIC_URL +
                        //   //         "/static/images/ic-delete.svg"
                        //   //       }
                        //   //       alt=""
                        //   //     />
                        //   //   ),
                        //   //   tooltip: "Delete",
                        //   //   onClick: (event, rowData) => {
                        //   //     handelDelete(rowData.id);
                        //   //   },
                        //   // },
                        // ]}
                        components={{
                          Container: (props) => (
                            <div id="Payment">
                              <Paper {...props} />
                            </div>
                          ),
                        }}
                        options={{
                          headerStyle: {
                            backgroundColor: "white",
                            color: "#245C7F",
                            fontSize: 12,
                          },
                          rowStyle: (rowData, index) => {
                            if (index % 2) {
                              return { backgroundColor: "#fff" };
                            }
                          },
                          sorting: true,
                          search: false,
                          toolbar: false,
                          paging: true,
                          pageSize: 3, // make initial page size
                          emptyRowsWhenPaging: false, // To avoid of having empty rows
                          pageSizeOptions: [5, 15, 20, 50],
                          paginationType: "stepped",
                          showFirstLastPageButtons: false,
                          actionsColumnIndex: -1,
                        }}
                      />
                    </div>
                    {/* <div className="">
                      <div className="accordion-item mt-2 ">
                        <h2
                          className="accordion-header"
                          id="panelsStayOpen-headingTwo"
                        >
                          <button
                            className="accordion-button collapsed"
                            style={{ color: "#008DC1" }}
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#panelsStayOpen-collapseTwo"
                            aria-expanded="false"
                            aria-controls="panelsStayOpen-collapseTwo"
                          >
                            <b>{t("Payment Additional Information")}</b>
                          </button>
                        </h2>
                        <div
                          id="panelsStayOpen-collapseTwo"
                          className="accordion-collapse collapse"
                          aria-labelledby="panelsStayOpen-headingTwo"
                        >
                          <div className="accordion-body">
                            <Form
                              role="form text-left"
                              onSubmit={handleSubmit(handleRegister)}
                              ref={form}
                              action="."
                              method="POST"
                              id="addPartyForm"
                            >
                              {
                                <>
                                  <div className="row">

                                    <div className="col-xl-6">
                                      <div className="form-group row">
                                        <label className="col-lg-12 col-form-label">
                                          {t("Tax Rate (Rent)")}{" "}
                                          <Tooltip
                                            content={t("TaxRate-Rent_Tooltip")}
                                          >
                                            <i className="fa fa-light fa-circle-info"></i>
                                          </Tooltip>
                                        </label>
                                        <div className="col-lg-12">
                                          <CurrencyInput
                                            id="input-example"
                                            name="input-name"
                                            allowDecimals="false"
                                            // disabled={taxsetup ==="Tax Rate Table"}
                                            value={tax_rate_rent}
                                            onValueChange={(value) =>
                                              setTax_Rate_Rent(value)
                                            }
                                            className="form-control"
                                            disableAbbreviations
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-xl-6">
                                      <div className="form-group row">
                                        <label className="col-lg-12 col-form-label">
                                          {t("Tax Rate (Fee)")}{" "}
                                          <Tooltip
                                            content={t("TaxRate-Fee_Tooltip")}
                                          >
                                            <i className="fa fa-light fa-circle-info"></i>
                                          </Tooltip>
                                        </label>
                                        <div className="col-lg-12">
                                          <CurrencyInput
                                            id="input-example"
                                            name="input-name"
                                            // disabled={taxsetup ==="Tax Rate Table" }
                                            allowDecimals="false"
                                            value={tax_rate_fee}
                                            onValueChange={(value) =>
                                              setTax_Rate_Fee(value)
                                            }
                                            className="form-control"
                                            disableAbbreviations
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-xl-6">
                                      <div className="form-group row">
                                        <label className="col-lg-12 col-form-label">
                                          {t("Deposit Amount")}{" "}
                                          <Tooltip
                                            content={t("DepositAmount_Tooltip")}
                                          >
                                            <i className="fa fa-light fa-circle-info"></i>
                                          </Tooltip>
                                        </label>
                                        <div className="col-lg-12">
                                          <CurrencyInput
                                            id="input-example"
                                            name="input-name"
                                            allowDecimals="false"
                                            value={deposit_amount}
                                            onValueChange={(value) =>
                                              setDeposit_amount(value)
                                            }
                                            className="form-control"
                                            disableAbbreviations
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <button
                                    type="submit"
                                    className="btn-continue border-0 btn btn-primary btn-gradient-primary btn-md"
                                  >
                                    {loading === false ? (
                                      t("Update")
                                    ) : (
                                      <ButtonLoading />
                                    )}
                                  </button>
                                  &nbsp;&nbsp;
                                </>
                              }
                              <CheckButton
                                style={{ display: "none" }}
                                ref={checkBtn}
                              />
                            </Form>
                          </div>
                        </div>
                      </div>
                    </div> */}
                  </div>
                  <div className="mt-2">
                    <ContractPaymentDetails
                      contractDate={start_date}
                      paymentRule={paymentrule}
                      paymentFrequency={paymentfrequency}
                      noTerms={contract_term}
                      monthlyAmount={amount}
                      payment_count={payment_count}
                      no_of_payments={noofpayments}
                      items={items}
                      contract_type={contract_type}
                      paymentdetails= {paymentitems}
                    />

                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <EditPaymentSchedules
            paymentid={paymentid}
            contract={id.contract_id}
            contractterm={id.contract_term}
            payment_rule={paymentrule}
            payment_frequency={paymentfrequency}
            contract_date={id.contract_start_date}
          />
        )
      ) : (
        <AddPaymentSchedules
          date={paymentscheduleenddate}
          contract={id.contract_id}
          contractterm={id.contract_term}
          payment_rule={paymentrule}
          payment_frequency={paymentfrequency}
          contract_date={id.contract_start_date}
        />
      )}
    </>
  );
}
export default PaymentScheduleList;
